import React, { useMemo, useState } from "react";
import { normalizeStyle } from "../utils/sectionStyle";
import { sectionTemplates } from "../../../data/database";
import FooterSectionEditor from "./sections/FooterSectionEditor";

export default function FooterEditorModal({ footer, onPatch, onClose, uploadImage, t = (k, f) => f }) {

  const [activeTab, setActiveTab] = useState("content");

  const templateKey = footer?.template || "template1";
  const tpl = sectionTemplates?.footersection?.[templateKey];

  const tplCfg = tpl?.config || {};
  const tplStyle = tpl?.style || {};

  const mergedCfg = useMemo(
    () => ({ ...tplCfg, ...(footer?.config || {}) }),
    [tplCfg, footer?.config]
  );

  const mergedStyle = useMemo(
    () => normalizeStyle({ ...tplStyle, ...(footer?.style || {}) }),
    [tplStyle, footer?.style]
  );

  const handleInputChange = (field, value) => {
    onPatch?.({ config: { [field]: value } });
  };

  const handleStyleChange = (field, value) => {
    onPatch?.({ style: { [field]: value } });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-hidden border flex flex-col">

        <div className="px-6 py-4 border-b flex items-center justify-between">
          <div>
            <div className="text-lg font-bold text-gray-900">
              {t("footerModal.title", "Edit Footer")}
            </div>
            <div className="text-sm text-gray-500">
              {t("footerModal.subtitle", "This is page footer, not a section.")}
            </div>
          </div>
          <button onClick={onClose} className="text-2xl text-gray-400 hover:text-gray-600">×</button>
        </div>

        <div className="px-6 pt-4">
          <div className="inline-flex gap-1 p-1 bg-gray-100 rounded-xl">
            <button
              type="button"
              onClick={() => setActiveTab("content")}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                activeTab === "content" ? "bg-white shadow ring-1 ring-gray-200" : "text-gray-600"
              }`}
            >
              {t("footerModal.tabs.content", "Content")}
            </button>
            <button
              type="button"
              onClick={() => setActiveTab("design")}
              className={`px-4 py-2 rounded-lg text-sm font-medium ${
                activeTab === "design" ? "bg-white shadow ring-1 ring-gray-200" : "text-gray-600"
              }`}
            >
              {t("footerModal.tabs.design", "Design")}
            </button>
          </div>
        </div>

        <div className="flex-1 min-h-0 p-6 overflow-y-auto overscroll-contain">
          {activeTab === "content" ? (
            <FooterSectionEditor
              config={mergedCfg}
              onChange={handleInputChange}
              uploadImage={uploadImage}
              t={t}
            />
          ) : (
            <div className="space-y-4">
              <div className="font-semibold text-gray-900">
                {t("footerModal.design.title", "Footer Colors")}
              </div>

              <div className="grid md:grid-cols-3 gap-4">
                <div>
                  <div className="text-sm text-gray-700 mb-1">
                    {t("footerModal.design.background", "Background")}
                  </div>
                  <input
                    type="color"
                    value={mergedStyle?.bgColor || "#0B1220"}
                    onChange={(e) => handleStyleChange("bgColor", e.target.value)}
                    className="h-10 w-20 rounded border"
                  />
                </div>

                <div>
                  <div className="text-sm text-gray-700 mb-1">
                    {t("footerModal.design.titleColor", "Title Color")}
                  </div>
                  <input
                    type="color"
                    value={mergedStyle?.titleColor || "#ffffff"}
                    onChange={(e) => handleStyleChange("titleColor", e.target.value)}
                    className="h-10 w-20 rounded border"
                  />
                </div>

                <div>
                  <div className="text-sm text-gray-700 mb-1">
                    {t("footerModal.design.subtitleColor", "Subtitle Color")}
                  </div>
                  <input
                    type="color"
                    value={mergedStyle?.subtitleColor || "#cbd5e1"}
                    onChange={(e) => handleStyleChange("subtitleColor", e.target.value)}
                    className="h-10 w-20 rounded border"
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t bg-gray-50 flex justify-end">
          <button onClick={onClose} className="px-4 py-2 rounded-lg border hover:bg-white">
            {t("footerModal.done", "Done")}
          </button>
        </div>
      </div>
    </div>
  );
}